import {request} from "@/api/request";
import Vue from "vue"

const state = {
    competitionCategoryList: [],
}

const getters = {
    getCompetitionCategoryList: state => state.competitionCategoryList,
}

const mutations = {
    updateCompetitionCategoryList(state, obj) {
        state.competitionCategoryList = obj.data;
    },
}
const actions = {
    setCompetitionCategory({commit, rootState}, {}) {
        try {
            request.get('contest/category' ,{ip:0}).then(res => {
                if (res.data.Data.Result.Info.type != 1) {
                    return false;
                }
                let categoryList = res.data.Data.Result.List
                commit('updateCompetitionCategoryList', {data: categoryList})
            })
        } catch (e) {
            console.log(e);
        }
    },
}
export default {namespaced: true, state, getters, mutations, actions}
